<section id="comunidade" class="comunidade">
    <div class="comunidade__image">
        <img class="logo-montreal"
             src="../../../assets/img/logo-montreal-white-novo.png"
             width="401"
             height="101"
             alt="Logo Montreal"/>
    </div>
    <div class="container comunidade__items">
        <div class="columns is-mobile is-gapless">
            <div class="column comunidade__items--item" *ngFor="let item of items" [ngStyle]="item.styleCss">
                <div class="comunidade__items--item-text">
                    <h3>{{item.title}}</h3>
                    <p>{{item.subtitle}}</p>
                </div>
                <div [ngClass]="item.classCss">
                    <button class="button is-responsive" (click)="goTo(item.link)">{{item.textButton}}</button>
                </div>
            </div>
        </div>
    </div>
</section>
